
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/components/auth/AuthProvider';

export const useUserRole = () => {
  const { user, session } = useAuth();

  return useQuery({
    queryKey: ['user-role', user?.id],
    queryFn: async () => {
      if (!user || !session) return 'Üye';

      try {
        const { data, error } = await supabase.rpc('get_current_user_role');
        
        if (error) {
          console.error('Error fetching user role:', error);
          return 'Üye';
        }
        
        return data || 'Üye';
      } catch (error) {
        console.error('Error calling get_current_user_role:', error);
        return 'Üye';
      }
    },
    enabled: !!user && !!session,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 1,
  });
};

export const useIsAdminOrModerator = () => {
  const { data: userRole } = useUserRole();
  return userRole === 'Yönetici' || userRole === 'Moderatör';
};
